import { EventListeners, MinzeElement, Reactive, Attrs } from 'minze'
import { Font } from '../../../constants'

export interface LvcCloseableModal {
  modalId: string
  modalStatus: string
  modalTitle: string
  titleSize: string
  noCloseButton?: boolean
  maxWidth?: string
  theme?: string
}

export class LvcCloseableModal extends MinzeElement {
  attrs: Attrs = [
    'modal-id',
    'modal-title',
    'no-close-button',
    'close',
    'max-width',
    ['theme', 'default'],
  ]
  static observedAttributes = ['close']
  _authHandler: any = null

  onCloseButtonClick() {
    this.closeModal()
  }

  onOverlayClick() {
    this.closeModal()
  }

  closeModal() {
    this.cast('close')
    this.remove()
  }

  onAttributeChange(name: string, oldValue: string, newValue: string) {
    if (name === 'close' && newValue === 'true') {
      this.closeModal()
    }
  }

  html = () => `
    <svg width="0" height="0" viewBox="0 0 480 300" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Assets" fill="none">
        <defs>
          <clipPath id="artist-slider-big-mask" clipPathUnits="objectBoundingBox" transform="scale(0.00208333333, 0.00333333333)">
            <path d="M254.597 299.894C312.19 300.622 405.585 297.453 458.928 295.209C469.156 294.779 477.087 285.296 477.074 273.971C477.028 231.25 480 190.841 480 140.625C480 88.3736 478.083 60.0604 477.507 22.4126C477.33 10.8495 468.812 1.52298 458.359 1.68357C395.992 2.64172 281.361 3.57732 243.787 1.36182C205.504 -0.895587 92.2701 0.118385 20.1108 1.09437C9.69686 1.23522 1.43851 10.7713 1.61762 22.2916C2.43946 75.1632 1.94203 128.76 0.770059 145.313C-0.266033 159.947 -0.196928 235.835 0.621387 275.418C0.843729 286.174 8.6767 294.594 18.3988 294.84C81.6442 296.443 195.453 299.145 254.597 299.894Z" id="Path"></path>
          </clipPath>
        </defs>
      </g>
    </svg>
    <div id="lvc-modal-overlay" class="lvc-modal-overlay">
    </div>
    <div class="lvc-modal-wrapper">
      <div id="lvc-modal" class="lvc-modal">
        ${
          !this.modalTitle && this.noCloseButton
            ? ''
            : `
          <div part="header" class="header">
            ${(this.modalTitle && `<div class="title" part="title">${this.modalTitle}</div>`) || ''}
            ${this.noCloseButton ? '' : `<div id="lvc-close-button"><lvc-circle-close-icon></lvc-circle-close-icon></div>`}
          </div>
        `
        }
        <slot></slot>
      </div>
    </div>
  `

  css = () => {
    let theme = ''

    if (this.theme === 'neat') {
      theme = `
        .lvc-modal, .lvc-modal-wrapper {
         --webkit-clip-path: none;
         clip-path: none;
        }

        .lvc-modal {
          padding: 16px;
          border-radius: 20px;
        }

        .title {
          text-transform: uppercase;
          font-size: 20px;
        }
      `
    }

    return `
      :host {
        z-index: 100000;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: block;
      }

      .title {
        font-family: ${Font.family};
        font-style: normal;
        font-weight: ${Font.weight.extraBold};
        font-size: 60px;
        line-height: 100%;
        font-feature-settings: 'tnum' on, 'lnum' on;
        color: #1E007D;
        flex: none;
        order: 0;
        flex-grow: 0;
      }
      
      #lvc-close-button {
        cursor: pointer;
      }

      .lvc-modal {
        -webkit-clip-path: url(#artist-slider-big-mask);
        clip-path: url(#artist-slider-big-mask);
        background: #fff;
        padding: 42px;
        border-radius: 20px;
        max-height: 100vh;
        overflow-y: auto;
        ${this.maxWidth ? `max-width: ${this.maxWidth}` : ``}
      }
      
      .lvc-modal-wrapper {
        -webkit-clip-path: url(#artist-slider-big-mask);
        clip-path: url(#artist-slider-big-mask);
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        padding: 2px;
        border-radius: 20px;
        background: #1E007D;
      }
      
      @media screen and (max-width: 730px) {
        .lvc-modal-wrapper {
          width: 95%;
        }
        .lvc-modal {
          padding: 22px;
        }
      }

      .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0px;
        min-width: 448px;
        width: 100%;
        height: 40px;
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
      }
      
      .lvc-modal-overlay {
        position: fixed; /* Stay in place */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgba(0,0,0,0.25);
        cursor: pointer;
      }

      @media screen and (max-width: 767px) {
        .title{
          font-size: 35px;
        }
        .lvc-modal {
          max-width: 100%;
        }
        .header {
          min-width: 0px;
        }
      }

      ${theme}
    `
  }

  eventListeners: EventListeners = [
    ['#lvc-modal-overlay', 'click', this.onOverlayClick.bind(this)],
    ['#lvc-close-button', 'click', this.onCloseButtonClick.bind(this)],
  ]
}
